import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Typography,
  Select,
  Option,
  Spinner,
} from "@material-tailwind/react";

import { useDispatch, useSelector } from "react-redux";

import TopCustomers from "./dashboard-graph-components/TopCustomers";
import RecentPayments from "./dashboard-graph-components/RecentPayments";

import SummaryCards from "./dashboard-graph-components/SummaryCards";
import RevenueChart from "./dashboard-graph-components/RevenueChart";
import WeeklyChart from "./dashboard-graph-components/WeeklyChart";
import PaymentMethodChart from "./dashboard-graph-components/PaymentMethodChart";
import PaymentStatusChart from "./dashboard-graph-components/PaymentStatusChart";
import { getDashboardAnalytics } from "@/store/slices/dashboardSlice";

const DashboardGraph = ({ fromDate = "", toDate = "" }) => {
  const dispatch = useDispatch();

  const { dashboard, loading } = useSelector(
    (state) => state.dashboard
  );

  const currentYear = new Date().getFullYear();

  const [year, setYear] = useState(currentYear);

  useEffect(() => {
    dispatch(
      getDashboardAnalytics({
        fromDate,
        toDate,
      })
    );
  }, [dispatch, fromDate, toDate]);

  const years = [];

  for (let i = currentYear; i >= currentYear - 5; i--) {
    years.push(i);
  }

 return (
  <div className="mb-8 flex flex-col gap-4">

    {/* Header */}
    <div className="flex flex-col md:flex-row justify-between items-center gap-1 md:gap-0 px-4 md:px-6">

      <div className="w-full md:flex-1">
        {/* <Typography variant="h5" color="blue-gray">
          Payment Dashboard
        </Typography> */}

        <Typography
          color="gray"
          className="font-normal"
        >
          Revenue analytics & payment overview
        </Typography>
      </div>

      {/* <div className="w-full md:w-48">

        <Select
          value={String(year)}
          label="Select Year"
          onChange={(value) => setYear(Number(value))}
        >
          {years.map((y) => (
            <Option key={y} value={String(y)}>
              {y}
            </Option>
          ))}
        </Select>

      </div> */}

    </div>

    {loading ? (
      <Card className="mx-4 md:mx-6">
        <CardBody className="flex justify-center items-center py-20">
          <Spinner className="h-10 w-10" />
        </CardBody>
      </Card>
    ) : (
      <>

        {/* Summary */}
        <div className="px-4 md:px-6">
          <SummaryCards summary={dashboard?.summary} />
        </div>

        {/* Revenue + Weekly */}
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 px-4 md:px-6">
          <RevenueChart
            data={dashboard?.monthly_revenue || []}
          />

          <WeeklyChart
            data={dashboard?.weekly_revenue || []}
          />
        </div>

        {/* Payment Method + Status */}
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 px-4 md:px-6">
          <PaymentMethodChart
            data={dashboard?.payment_methods || []}
          />

          <PaymentStatusChart
            data={dashboard?.payment_status || []}
          />
        </div>

        {/* Tables */}
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 px-4 md:px-6 mb-8">
          <TopCustomers
            data={dashboard?.top_customers || []}
          />

          <RecentPayments
            data={dashboard?.recent_payments || []}
          />
        </div>

      </>
    )}
  </div>
);
};

export default DashboardGraph;